import type { Styles } from '@adornis/ass/style.js';
import { XToggleContent } from '@adornis/chemistry/elements/components/x-toggle-content.js';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement cr-toggle-content
 */
@customElement('cr-toggle-content')
export class ChromiumToggleContent extends XToggleContent {
  @property({ type: Boolean }) startOpen = false;

  override connectedCallback(): void {
    this.open = this.open || this.startOpen;
    super.connectedCallback();
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host #content': {
          marginRight: `calc(${this.spacing.md} + 20px)`,
        },
      },
    ] as Styles[];
  }
}
